import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  Sort,
  TabActionDialog
} from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { CoverDetailsPageTab } from "./components/CoverPage";

export const coverSection = "/cover/";
export const coverListPath = coverSection;
export const coverListUrl = (params?: CoverListUrlQueryParams) =>
  coverListPath + "?" + stringifyQs(params);

export type CoverListUrlQueryParams = ActiveTab &
  CoverListUrlFilters &
  CoverListUrlSort &
  BulkAction &
  Dialog<CoverListUrlDialog> &
  Pagination;
export type CoverListUrlFilters = Filters<CoverListUrlFiltersEnum>;

export type CoverListUrlDialog = "remove" | TabActionDialog;

export type CoverListUrlSort = Sort<CoverListUrlSortField>;

export enum CoverListUrlFiltersEnum {
  query = "query"
}

export enum CoverListUrlSortField {
  name = "name",
  createDate = "createDate",
  subtitle = "subtitle",
  title = "title"
}
export type CoverUrlDialog =
  | "unassign-product"
  | "unassign-category"
  | "remove"
  | "assign-product"
  | "assign-category";

export type CoverUrlQueryParams = BulkAction &
  Dialog<CoverUrlDialog> &
  Pagination &
  ActiveTab<CoverDetailsPageTab>;

export const coverPath = (id: string) => urlJoin(coverSection, id);
export const coverUrl = (id: string, params?: CoverUrlQueryParams) =>
  coverPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export type CoverAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type CoverAddUrlQueryParams = Dialog<CoverAddUrlDialog> & Pagination;

export const coverAddPath = urlJoin(coverSection, "add");

export const coverAddUrl = (params?: CoverAddUrlQueryParams) =>
  coverAddPath + "?" + stringifyQs(params);
